import { render, staticRenderFns } from "./LegacyMobileValues.vue?vue&type=template&id=381ecc5c&scoped=true&"
import script from "./LegacyMobileValues.vue?vue&type=script&lang=js&"
export * from "./LegacyMobileValues.vue?vue&type=script&lang=js&"
import style0 from "./LegacyMobileValues.vue?vue&type=style&index=0&id=381ecc5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381ecc5c",
  null
  
)

export default component.exports